import { useDataValue } from 'Simple/Data.js'
import { useMutation } from 'Data/Api'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'
import mutationRemoveHubAccess from './mutation-remove-hub-access.graphql.js'
import mutation_set_past from './setPastMutation.graphql.js'
import mutation_delete_professional_relationship from './deleteProfessionalRelationshipMutation.graphql.js'

export function useOnClick(props) {
  let professional = useDataValue({
    context: 'professional',
    viewPath: props.viewPath,
  })
  let [, executeMutationSetPast] = useMutation(mutation_set_past)
  let [, executeMutationDeleteProfessionalRelationship] = useMutation(
    mutation_delete_professional_relationship
  )
  let removeHubAccess = useDataActionRemoveHubAccess(props)

  let setFlowTo = useSetFlowTo(props.viewPath)
  let action = useDataValue({
    context: 'option',
    viewPath: props.viewPath,
    path: 'id',
  })
  return async function onClick() {
    switch (action) {
      case 'REMOVE': {
        return remove()
      }
      case 'EDIT': {
        return edit()
      }
      case 'MARK_AS_PAST': {
        return await markAsPast()
      }
      case 'REMOVE_FROM_PAST': {
        return removeFromPast()
      }
      case 'REMOVE_HUB_ACCESS': {
        return removeHubAccess()
      }
      default: {
        break
      }
    }
  }

  async function remove() {
    await executeMutationDeleteProfessionalRelationship({
      id: professional.id,
    })
  }
  function edit() {
    setFlowTo(normalizePath(props.viewPath, '../../Edit/Content'))
  }
  async function markAsPast() {
    await executeMutationSetPast({ id: professional.id, past: true })
  }
  async function removeFromPast() {
    await executeMutationSetPast({ id: professional.id, past: false })
  }
}

function useDataActionRemoveHubAccess(props) {
  let [, executeMutation] = useMutation(mutationRemoveHubAccess)
  let user_id = useDataValue({
    viewPath: props.viewPath,
    context: 'professional',
    path: 'other.person.public_user.id',
  })
  let email = useDataValue({
    viewPath: props.viewPath,
    context: 'professional',
    path: 'other.person.public_user.account.email',
  })
  let core_user_id = useDataValue({
    viewPath: props.viewPath,
    context: 'professional',
    path: 'other.person.core_user_id',
  })
  let [, notify] = useNotifications()
  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onActionRemoveHubAccess() {
    if (core_user_id) {
      notify(
        notifyError(
          `This email ${email} is currently associated with a system user and cannot be removed from the Practice Hub.`
        )
      )
      return
    }

    if (
      !window.confirm(
        `This will remove ${email} from the Practice Hub, preventing login with this email. The email will be available for use with another profile if needed.\n\nAre you sure you want to proceed?
`
      )
    )
      return

    let mutationResponse = await executeMutation({ user_id })

    if (mutationResponse.error || !mutationResponse.data.update_users_by_pk) {
      notify(notifyError(`Failed to remove Practice Hub access to ${email}.`))
    } else {
      notify(notifySuccess(`Practice Hub Access removed for ${email}!`))
    }

    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
